<div class="rg-page-header">
  <div>
    <h3 class="fw-bold mb-1">Profile</h3>
    <p class="text-muted mb-0">
      Manage your admin account and password.
    </p>
  </div>
</div>

<div class="container-fluid p-4">
  <div class="row g-3">
    <div class="col-12 col-xl-5">
      <div class="card border-0 shadow-sm rg-card">
        <div class="card-header bg-white">
          <strong>Account Information</strong>
        </div>

        <div class="card-body">
          <div class="mb-3">
            <small class="text-muted">Full Name</small>
            <div class="fw-semibold">{{ adminName }}</div>
          </div>

          <div class="mb-3">
            <small class="text-muted">Email</small>
            <div class="fw-semibold">{{ adminEmail }}</div>
          </div>

          <div>
            <small class="text-muted">Role</small>
            <div>
              <span class="badge text-bg-primary">{{ adminRole }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-7">
      <div class="card border-0 shadow-sm rg-card">
        <div class="card-header bg-white">
          <strong>Change Password</strong>
        </div>

        <form (ngSubmit)="changePassword()">
          <div class="card-body">
            <div class="mb-3">
              <label class="form-label">Current Password</label>
              <input
                type="password"
                class="form-control"
                name="currentPassword"
                [(ngModel)]="currentPassword">
            </div>

            <div class="mb-3">
              <label class="form-label">New Password</label>
              <input
                type="password"
                class="form-control"
                name="newPassword"
                [(ngModel)]="newPassword">
            </div>

            <div>
              <label class="form-label">Confirm New Password</label>
              <input
                type="password"
                class="form-control"
                name="confirmPassword"
                [(ngModel)]="confirmPassword">
            </div>
          </div>

          <div class="card-footer bg-white text-end">
            <button class="btn btn-primary" type="submit" [disabled]="changingPassword">
              <span *ngIf="!changingPassword">Change Password</span>
              <span *ngIf="changingPassword">Changing...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>